/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'react',
	'mobx-react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'../../../lib/@waca/core-client/js/core-client/ui/KeyCodes'
], function(
	React,
	MobxReact,
	BA_UI_CARBON_TOOLKIT,
	PropTypes,
	KeyCodes
) {
	const { Label, SVGIcon } = BA_UI_CARBON_TOOLKIT;

	const BASE_CLASSNAME = 'properties--controls--InlineIconPicker';

	const getUISpec = (props) => {
		const { item } = props;
		let spec = item;
		if (item && item.editor && item.editor.uiControl) {
			spec = item.editor.uiControl;
		}
		return spec;
	};

	class InlineIconPicker extends React.Component {
		render() {
			const { style } = this.props;
			const item = getUISpec(this.props);
			const containerClassName = this.props.className;
			const { readOnly } = item;
			const className = containerClassName + (readOnly ? ' ' + BASE_CLASSNAME + '--disabled' : '');
			const containerProps = {
				style,
				className,
				'data-property-id': this.props.item.id
			};
			return (
				<div {...containerProps}>
					{this.renderLabel(item)}
					{this.renderControl(item)}
				</div>
			);
		}

		renderLabel(item) {
			return (
				<Label
					className={BASE_CLASSNAME + '--label'}
					label={item.label}
				/>
			);
		}

		renderControl({ items, values, readOnly, allowMultiple }) {
			const {
				item: {
					setPropertyValue
				}
			} = this.props;

			let onClick = () => {};
			if (!readOnly) {
				if (allowMultiple) {
					onClick = (item) => {
						const newValue = items
							.filter(item => values && values.includes(item.name));
						const index = newValue.findIndex(_item => _item.name === item.name);
						if (index === -1) {
							newValue.push(item);
						} else {
							newValue.splice(index, 1);
						}
						setPropertyValue(newValue);
					};
				} else {
					onClick = (item) => {
						setPropertyValue([item]);
					};
				}
			}

			return (
				<div className={BASE_CLASSNAME + '--control'}>
					{items.map((item, key) => {
						const iconProps = {
							iconId: item.value,
							alt: item.label
						};
						const isSelected = values && values.includes(item.name);
						return (
							<div
								key={key}
								tabIndex="0"
								onClick={() => onClick(item)}
								onKeyDown={(event) => {
									if ([ KeyCodes.ENTER, KeyCodes.SPACE ].indexOf(event.keyCode) !== -1) {
										onClick(item);
										event.stopPropagation();
									}
								}}
								className={BASE_CLASSNAME + '--control--icon' + (isSelected ? ' ' + BASE_CLASSNAME + '--control--icon--selected' : '')}
							>
								<SVGIcon
									{...iconProps}
								/>
							</div>
						);
					})}
				</div>
			);
		}
	}

	InlineIconPicker.propTypes = {
		item: PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			readOnly: PropTypes.bool.isRequired,
			allowMultiple: PropTypes.bool.isRequired,
			items: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string,
					name: PropTypes.string,
					value: PropTypes.string
				})
			),
			setPropertyValue: PropTypes.func.isRequired
		}).isRequired,
		style: PropTypes.object,
		className: PropTypes.string
	};
	InlineIconPicker.defaultProps = {};

	return MobxReact.observer(InlineIconPicker);
});